import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import Typography from 'material-ui/Typography';

const styleSheet = theme => ({
  root: {
    maxWidth: theme.spacing.unit * 110,
    textAlign: 'center',
    margin: 'auto',
    padding: `${theme.spacing.unit * 3}px ${theme.spacing.unit * 2}px`,
  },
  copyright: {
    color: '#bbc7cc',
  }
});

function HomeFooter(props) {
  const { classes } = props;

  return (
    <footer className={classes.root}>
      <Typography className={classes.copyright}>
        Copyright © 2019 · All Rights Reserved ·
        <a className={classes.copyright} href="mailto:sung@sungthecoder">SungTheCoder</a>
      </Typography>
    </footer>
  );
}

HomeFooter.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styleSheet)(HomeFooter);


// WEBPACK FOOTER //
// ./src/components/HomePage/Iteq/Footer.jsx